import {
  getToken,
  setToken,
  getCompany,
  setCompany,
  removeToken,
  getAvatar,
  setAvatar,
  getName,
  setName,
  getTitle,
  setTitle,
  getProjectImage,
  setProjectImage,
  getCredits,
  setCredits,
  setProject,
  getAddress,
  setAddress,
  removeAddress,
  getQueryString
} from '@/utils/auth'
import {
  getApi,
  postApi
} from '@/api'

const user = {
  namespaced: true,
  state: {
    miniApp: false, // 是否是小程序里
    token: getToken() || '',
    company: getCompany() || 'Tencent',
    address: getAddress() || '',
    name: getName() || '',
    credits: getCredits() || '',
    avatar: getAvatar() || '',
    roles: [],
    showTab: false,
    showNav: true,
    showBack: false,
    title: getTitle() || '',
    projectImage: getProjectImage() || '',
    tabIndex: 0,
    cartCount: 0
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_NAME: (state, name) => {
      state.name = name
      setName(name)
    },
    SET_CREDITS: (state, credits) => {
      state.credits = credits
      setCredits(credits)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
      setAvatar(avatar)
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_SHOW_TAB: (state, status) => {
      state.showTab = status
    },
    SET_SHOW_BACK: (state, status) => {
      state.showBack = status
    },
    SET_TITLE: (state, title) => {
      state.title = title
    },
    SET_PROJECT_IMAGE: (state, image) => {
      state.projectImage = image
    },
    SET_TAB_INDEX: (state, index) => {
      state.tabIndex = index
    },
    SET_CARTCOUNT: (state, count) => {
      state.cartCount = count
    },
    SET_ADDRESS: (state, address) => {
      state.address = address
      removeAddress()
      setAddress(address)
    },
    SET_SHOW_NAV: (state, status) => {
      state.showNav = status
    },
    SET_MiniApp: (state, status) => {
      state.miniApp = status
    }
  },

  actions: {
    RefreshTabIndex: ({
      commit
    }, index) => {
      commit('SET_TAB_INDEX', index)
    },
    RefreshTitle: ({
      commit
    }, title) => {
      commit('SET_TITLE', title)
    },
    RefreshProjectImage: ({
      commit
    }, image) => {
      commit('SET_PROJECT_IMAGE', image)
    },
    RefreshShowTab: ({
      commit
    }, status) => {
      commit('SET_SHOW_TAB', status)
    },
    RefreshShowNav: ({
      commit
    }, status) => {
      commit('SET_SHOW_NAV', status)
    },

    RefreshShowBack: ({
      commit
    }, status) => {
      commit('SET_SHOW_BACK', status)
    },

    RefreshToken: ({
      commit
    }, token) => {
      commit('SET_TOKEN', token)
    },
    RefreshCartCount: async ({
      commit
    }, count) => {
      if (!count) {
        let res = await getApi('/mall/carts/count', {})
        count = res.data.count
      }
      commit('SET_CARTCOUNT', count)
    },
    RefreshAddress: async ({
      commit
    }, address) => {
      if (!address) {
        let res = await getApi('/mall/addresses/mine', {})
        if (res.data.length) {
          address = res.data.filter(ele => ele.defaulted)[0]
        }
      }
      address = address || null
      commit('SET_ADDRESS', address)
    },
    RefreshMiniApp: ({
      commit
    }, index) => {
      commit('SET_MiniApp', index)
    },
    /**
     *
     * @param {*} param0
     * @param {*} code 非必填 授权返回的code
     */
    Login ({
      dispatch
    }, code) {
      code = code || getQueryString('code')
      return new Promise((resolve, reject) => {
        postApi('/base/users/gongzhonghaoLogin', {
          code
        }).then(res => {
          let userId = res.data._id
          dispatch('RefreshToken', userId)
          dispatch('GetInfo', userId)
          resolve(userId)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Authorization (context, routerPath = '/') {
      let redirectUrl = ''
      routerPath = '/#' + routerPath
      let devPath = 'https://shop-dev.zoombin.com/question'
      let prodPath = 'https://shop.zoombin.com/question'
      if (window.location.hostname === 'shop-dev.zoombin.com') {
        redirectUrl = devPath + routerPath
      } else {
        redirectUrl = prodPath + routerPath
      }
      postApi('base/weixin/getLoginUrl', {
        redirectUrl
      }).then(res => {
        window.location.href = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    checkLoginNoAuth ({dispatch, state}) {
      if (!state.token) {
        return false
      }
      return true
    },
    checkLogin ({dispatch, state}, routerPath = '/') {
      if (!state.token) {
        setTimeout(() => {
          dispatch('Authorization', routerPath)
        }, 0)
        return false
      }
      return true
    },
    // 获取用户信息
    GetInfo ({
      commit,
      state
    }, userId) {
      return new Promise((resolve, reject) => {
        getApi('base/users/details', {
          _id: userId
        }).then(res => {
          commit('SET_NAME', res.data.name)
          commit('SET_AVATAR', res.data.face)
          commit('SET_CREDITS', res.data.credits)
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        postApi('users/logout').then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js